import React from "react";
import "./PartyMakeupOn.css";

function PartyMakeupOn(props) {
  const { polygon34, partyMakeup } = props;

  return (
    <div className="party-makeup-on">
      <div className="overlap-group-11">
        <div className="rectangle-124"></div>
        <img className="polygon-34" src={polygon34} />
        <div className="party-makeup-8 poppins-medium-white-10px">{partyMakeup}</div>
      </div>
    </div>
  );
}

export default PartyMakeupOn;
